export default __webpack_public_path__ + "static/media/main-clear.8f3362e0.jpeg";